import {put} from 'redux-saga/effects';
import {isAxiosError} from 'typescript/guards/AxiosGuards';

import {setErrorAC} from '../appSlice';

export function* handleError(error: unknown, errorMessage: string): Generator<unknown, void, any> {
  if (!isAxiosError(error)) return;

  const errorCode = error.response?.status;

  switch (errorCode) {
    case 500:
      yield put(setErrorAC(errorMessage));
      break;
    default:
      yield put(setErrorAC('Unknown error'));
      break;
  }
}
